import { Validators } from '@angular/forms';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';
import { FormInputCheckboxComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-checkbox/form-input-checkbox.component';
import { FormInputNumberComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-number/form-input-number.component';
import {
  FieldConfig,
  NewLineField,
} from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-config.interface';
import { FieldInputNumberConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-input-number-config.interface';
import { FormSelectComponent } from '../../../../../../../shared/modules/configurable-form/components/form-select/form-select.component';
import { FieldSelectConfig } from '../../../../../../../shared/modules/configurable-form/components/form-select/models/field-select-config.interface';
import { RmsFormConfig } from '../../../../models/rms-form-config';
import {
  SingleApplicationsLoaderService,
  SingleSpacingsLoaderService,
  SingleUnloadTypesLoaderService,
} from '../../../../services/config-loader/loaders/single-catalogs.loader.service';
import { ContractsOptionLoaderOpenPlatformService } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/loaders/open-platform/contract.loader.service';
// payment term form field
import { SingleCatalogsEffects } from '../../../../effects/single-catalogs.effects';
import { defaultDateTranslationNames } from '@ordersnproducts/modules/order-builder/modules/specification/configs/defaultDateTranslationNames';
import { MInDayProvider } from '@ordersnproducts/modules/order-builder/modules/specification/providers/min-day.provider';
import { FormInputDateComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-date/form-input-date.component';
import { FieldDateInputConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-date/models/field-date-input.config';
import { FormInputTimeComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-time/form-input-time.component';
import { TimepickerHourFormat } from '@ordersnproducts/modules/shared/components/cmx-timepicker/cmx-timepicker.component';
import { FieldInputTimeConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-input-time-config.interface';
import { LoadSingleCatalogsUnloadType } from '../../../../services/config-loader/commands/single-catalogs-unload-type.command.service';
import { LoadSingleCatalogsApplication } from '../../../../services/config-loader/commands/single-catalogs-application.command.service';
import { LoadSingleCatalogsSpacing } from '../../../../services/config-loader/commands/single-catalogs-spacing.command.service';
import { LoadContractOpenPlatformCommandService } from '../../../../services/config-loader/commands/open-platform/load-contract.command.service';
import { FormInputComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input/form-input.component';
import { FieldProductSelectionConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-product-selection-config.interface';
import { SALES_DOCUMENT_TYPE_ID } from '@ordersnproducts/modules/shared/constants/sales-document-type-id';
import { FormHybrisProductSelectionComponent } from '@ordersnproducts/modules/order-builder/modules/specification/components/form/form-hybris-product-selection/form-hybris-product-selection.component';
import { SetTimepickerDateFromDatepickerCommand } from '@ordersnproducts/modules/order-builder/modules/specification/services/commands/set-timepicker-date-from-datepicker.command';
import { HandleDecimalCommand } from '@ordersnproducts/modules/order-builder/modules/specification/services/commands/handle-decimal.command';
import { DecimalErrorProvider } from '../../../../providers/open-platform/decimal-error.provider';
import { SpecFieldTestIds } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-test-ids.enum';

export const simmaUL = {
  recipe: [
    {
      type: FormInputComponent,
      label: 'id',
      name: SpecFieldNames.ID,
      containerClassNames: ['d-none'],
      placeholder: 'id',
    } as FieldConfig,
    {
      type: FormHybrisProductSelectionComponent,
      label: 'views.specifications.product_description',
      name: SpecFieldNames.PRODUCT_SELECTION,
      dataTId: SpecFieldTestIds.PRODUCT_DESCRIPTION,
      showSearch: true,
      placeholder: '',
      btnText: 'views.specifications.select',
      validation: [Validators.required],
      preloadTopProducts: true,
      containerClassNames: ['field-12x field-md-6x retail-control'],
      onChange: [
        LoadContractOpenPlatformCommandService,
        LoadSingleCatalogsUnloadType,
        LoadSingleCatalogsApplication,
        LoadSingleCatalogsSpacing,
      ],
      dropdownSalesDocumentTypes: [SALES_DOCUMENT_TYPE_ID.CONTRACT],
    } as FieldProductSelectionConfig,
    {
      type: FormInputNumberComponent,
      label: 'views.specifications.quantity',
      dataTId: SpecFieldTestIds.QUANTITY,
      containerClassNames: ['field-11x field-md-2x retail-control'],
      name: SpecFieldNames.QUANTITY,
      min: 2,
      value: 2,
      max: 999,
      step: 0.5,
      validation: [Validators.required, Validators.max(999), Validators.min(2)],
      decimals: 1,
      onChange: [HandleDecimalCommand],
      suffix: ' m3',
      errorMessage: DecimalErrorProvider.ErrorMessage,
    } as FieldInputNumberConfig,
    {
      type: FormInputCheckboxComponent,
      name: SpecFieldNames.ADJUSTMENT,
      dataTId: SpecFieldTestIds.ADJUSTMENT,
      value: false,
      containerClassNames: ['field-6x field-md-2x retail-control specification-adjustment il-alignment'],
      placeholder: 'views.specifications.kicker',
    } as FieldConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormInputDateComponent,
      label: 'views.specifications.request_date',
      name: SpecFieldNames.DATE,
      dataTId: SpecFieldTestIds.REQUEST_DATE,
      containerClassNames: ['field-12x field-md-3x rms-mod'],
      placeholder: '',
      onChange: [SetTimepickerDateFromDatepickerCommand],
      translationNames: defaultDateTranslationNames,
      validation: [Validators.required],
      min: MInDayProvider,
      hideOutsideDays: true,
    } as FieldDateInputConfig,
    {
      type: FormInputTimeComponent,
      label: 'views.specifications.request_time',
      name: SpecFieldNames.TIME,
      dataTId: SpecFieldTestIds.REQUEST_TIME,
      containerClassNames: ['field-12x field-md-3x rms-mod'],
      placeholder: '',
      minuteStep: 1,
      hourFormat: TimepickerHourFormat.format24,
      validation: [Validators.required],
    } as FieldInputTimeConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormSelectComponent,
      label: 'views.specifications.contract',
      name: SpecFieldNames.CONTRACT_SELECT,
      dataTId: SpecFieldTestIds.CONTRACT_SELECT,
      containerClassNames: ['field-12x field-md-6x retail-control'],
      optionsLoader: ContractsOptionLoaderOpenPlatformService,
      placeholder: 'views.specifications.select_contract',
      onChange: [],
      rehydrate: true,
      disabled: true,
    } as FieldSelectConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormSelectComponent,
      label: 'views.specifications.element',
      name: SpecFieldNames.APPLICATION,
      dataTId: SpecFieldTestIds.APPLICATION,
      optionsLoader: SingleApplicationsLoaderService,
      containerClassNames: ['field-12x field-md-4x retail-control'],
      placeholder: 'views.specifications.select_element',
      validation: [Validators.required],
      dynamicEffects: [SingleCatalogsEffects],
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.spacing',
      name: SpecFieldNames.SPACING,
      dataTId: SpecFieldTestIds.SPACING,
      containerClassNames: ['field-12x field-md-4x retail-control'],
      placeholder: 'views.specifications.select_spacing',
      optionsLoader: SingleSpacingsLoaderService,
      validation: [Validators.required],
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.placement.method',
      name: SpecFieldNames.UNLOAD_TYPE,
      dataTId: SpecFieldTestIds.UNLOAD_TYPE,
      containerClassNames: ['field-12x field-md-4x retail-control'],
      placeholder: 'views.specifications.select_placement.method',
      optionsLoader: SingleUnloadTypesLoaderService,
      validation: [],
    } as FieldSelectConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
  ],
} as RmsFormConfig;
